import type { RouteRecordRaw } from 'vue-router';
import { buildRootURL } from '@centric-os/helpers';
import { LabsRoutePathNames, LabsRouteNames } from './enums';

const Component = () => import('./components/LabsPage.vue');

export * from './enums';

export const route: RouteRecordRaw = {
  path: buildRootURL(LabsRoutePathNames.LABS),
  name: LabsRouteNames.LABS,
  meta: {
    title: 'Labs',
    requireAuth: true,
  },
  component: Component,
};
